import { render, staticRenderFns } from "./SquareTriangle.vue?vue&type=template&id=68c6fd83&"
import script from "./SquareTriangle.vue?vue&type=script&lang=js&"
export * from "./SquareTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports